<prlw-attached-files-ui
  [attachedFiles]="attachedFiles$ | async"
  (eventRemoveAttachedFile)="eventRemoveAttachedFile($event)"
></prlw-attached-files-ui>
